exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "input[data-v-c351ff2c]{color:#000}.registration_box_area .form-group input[data-v-c351ff2c]{padding:0 10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c351ff2c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/app/commons/LoginForm.vue
// module id = 86
// module chunks = 0 1 2